export enum UnverifiedShiftsEvents {
  TIMESHEET_UPLOAD_STARTED = "timesheet-upload-started",
  TIMESHEET_UPLOADED = "timesheet-uploaded",
  TIMESHEET_UPLOAD_ERROR = "timesheet-upload-error",
}
